'use client';

import { useTranslation } from '@/lib/i18n';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import { CSSProperties, ReactNode } from 'react';

interface DataEmptyProps {
  image?: ReactNode;
  // 可以根据需要添加其他props，例如提示文本等
  message?: string;
  classNames?: Partial<Record<'wrapper' | 'image' | 'message', string>>;
  styles?: Partial<Record<'wrapper' | 'image' | 'message', CSSProperties>>;
}
export default function DataEmpty(props: DataEmptyProps) {
  const { message, image, classNames, styles } = props;
  const { t } = useTranslation();

  return (
    <div
      className={cn('flex flex-col items-center gap-4 justify-center', classNames?.wrapper)}
      style={styles?.wrapper}
    >
      {typeof image === 'string' ? (
        <Image
          src={image || '/image/empty_data.png'}
          width="150"
          height="150"
          alt=""
          className={classNames?.image}
          style={styles?.image}
        />
      ) : (
        image
      )}

      <div className={cn('text-[#757575]', classNames?.message)} style={styles?.message}>
        {message || t('No data yet')}
      </div>
    </div>
  );
}
